import { LoadableLazy } from '@confluence/loadable';

export const ReverseTrialLozengeListItemExperiment = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ReverseTrialLozengeListItemExperiment" */ '../src/ReverseTrialLozengeExperiment/ReverseTrialListItem'
			)
		).ReverseTrialListItemWithErrorBoundary,
});
